$(() => {
	APP.init();
});
